$(() => {
	APP.init();
});
